module.exports = __webpack_public_path__ + "img/first-1.f3fb2efd.webp";